import { formatDateForCommit } from "../helpers/DateHelper";

export const gitMetricColDef = [
    {
        field: "developer",
        headerName: "Developer Name",
        filter: "agTextColumnFilter",
        width: 170,
        cellStyle: { textAlign: 'left' },
        enableRowGroup: true ,
        enableRowGroup: true ,
    },
    {
        field: "repositoryName",
        headerName: "Repository Name",
        filter: "agTextColumnFilter",
        width: 170,
        cellStyle: { textAlign: 'left' },
        valueGetter: (params) => params.data?.repoName || "" ,
        enableRowGroup: true ,
    },
    {
        field: "lastCommitDate",
        headerName: "# Last Commit Date",
        headerTooltip: "Date of last commit",
        width: 160, 
        valueGetter: (params) => params.data?.lastDate || ""
    },
    {
        field: "totalCommits",
        headerName: "# Commits",
        headerTooltip: "Total Number of Commits",
        filter: "agNumberColumnFilter",
        width: 150,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalCommits || 0) ,
        sort: 'desc',
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalFilesChanged",
        headerName: "# Files Changed",
        headerTooltip: "Distinct File Changes For Commits In Date Range",
        filter: "agNumberColumnFilter",
        width: 140,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalFilesChanged || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "changesCountTotal",
        headerName: "# LOC: Total",
        headerTooltip: "Total Number of Lines Changes",
        filter: "agNumberColumnFilter",
        width: 130,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.changesCountTotal || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalHoursWorked",
        headerName: "# Non-Calls Worked Hours",
        headerTooltip: "Number of Non-Calls Worked Hours",
        filter: "agTextColumnFilter",
        width: 170,
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalHoursWorked || 0) ,
        valueFormatter: (params) => {
            if (params.value === undefined || params.value === null) return '0';
            return params?.value?.toFixed(2);
        },
        aggFunc: 'first',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalHoursInCall",
        headerName: "# InCall Hours",
        headerTooltip: "Number of InCall Hours",
        filter: "agTextColumnFilter",
        width: 140,
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalHoursWorkedInCall || 0) ,
        valueFormatter: (params) => {
            if (params.value === undefined || params.value === null) return '0';
            return params?.value?.toFixed(2);
        },
        aggFunc: 'first',
        suppressAggFuncInHeader: true
    },
    {
        field: "hrmsWorkHours",
        headerName: "Hrms Work Hours",
        headerTooltip: "Hrms Work Hours",
        filter: "agTextColumnFilter",
        width: 140,
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.hrmsWorkHours || 0) ,
        valueFormatter: (params) => {
            if (params.value === undefined || params.value === null) return '0';
            return params?.value?.toFixed(2);
        },
        aggFunc: 'first',
        suppressAggFuncInHeader: true
    },
    {
        field: "IrregularActivityTime",
        headerName: "# Irregular Activity Time",
        headerTooltip: "Irregular Activity Time",
        filter: "agTextColumnFilter",
        width: 140,
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.irregularActivityTime || 0) ,
        valueFormatter: (params) => {
            if (params.value === undefined || params.value === null) return 0;
            return params?.value?.toFixed(2);
        },
        aggFunc: 'first',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalMergedPrs",
        headerName: "# Merged PRs",
        headerTooltip: "Number of Merged Pull Requests",
        filter: "agNumberColumnFilter",
        width: 150,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalMergedPrs || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },

    {
        field: "changesCountRemoved",
        headerName: "# LOC: Deleted",
        headerTooltip: "Number of Removed Lines",
        filter: "agNumberColumnFilter",
        width: 140,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.changesCountRemoved || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "changesCountAdd",
        headerName: "# LOC: Added",
        headerTooltip: "Number of Lines Changes",
        filter: "agNumberColumnFilter",
        width: 140,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.changesCountAdd || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },

    {
        field: "totalDeclinedPrs",
        headerName: "# Declined PRs",
        headerTooltip: "Number of Declined Pull Requests",
        filter: "agNumberColumnFilter",
        width: 140,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalDeclinedPrs || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalOpenPrs",
        headerName: "# Open PRs",
        headerTooltip: "Number of Open Pull Requests",
        filter: "agNumberColumnFilter",
        width: 140,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalOpenPrs || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalPrComments",
        headerName: "# PR Comments",
        headerTooltip: "Number of Open Pull Requests",
        filter: "agTextColumnFilter",
        width: 140,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalPrComments || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    }


];

export const defaultColDef = {
    wrapHeaderText: true,
    autoHeaderHeight: true,
    singleClickEdit: true,
    suppressAggFuncInHeader:true
}

export const commitDetailsColDef = [
    {
        field: "hash",
        headerName: "Commit Hash",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        field: "addedChanges",
        headerName: "# LOC: Added",
        headerTooltip: "Number of Added Lines",
        filter: "agNumberColumnFilter",
        width: 110,
        type: 'numericColumn', // Tells AG Grid to treat this as a number column
        valueParser: (params) => Number(params.newValue), // Converts input to number if editable
        valueGetter: (params) => Number(params.data?.addedChanges || 0), // Ensures sort uses number
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "removedChanges",
        headerName: "# LOC: Deleted",
        headerTooltip: "Number of Removed Lines",
        filter: "agNumberColumnFilter",
        width: 110,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.removedChanges || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalChanges",
        headerName: "# LOC: Total",
        headerTooltip: "Total Number of Lines Changed",
        filter: "agNumberColumnFilter",
        width: 110,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalChanges || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "message",
        headerName: "Message",
        headerTooltip: "Commit Message",
        filter: "agNumberColumnFilter",
        width: 440,
    },
    {
        field: "totalfileschanged",
        headerName: "# Files Changed",
        headerTooltip: "File Changes For Commit",
        filter: "agNumberColumnFilter",
        width: 120,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalfileschanged || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "commitDate",
        headerName: "Date",
        headerTooltip: "Commit Date",
        valueFormatter: formatDateForCommit,
        width: 150,
    },
];

export const prDetailsColDef = [
    {
        field: "prId",
        headerName: "PR-ID",
        headerTooltip: "Pull Request ID",
        filter: "agNumberColumnFilter",
        width: 150,
    },
    {
        field: "title",
        headerName: "PR Title",
        headerTooltip: "Title of PR",
        filter: "agTextColumnFilter",
        width: 350,
    },
    {
        field: "sourceBranch",
        headerName: "Source Branch",
        headerTooltip: "Source Branch",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        field: "destinationBranch",
        headerName: "Destination Branch",
        headerTooltip: "Destination Branch",
        filter: "agTextColumnFilter",
        width: 150,
    },
    {
        field: "prCommentCount",
        headerName: "# Comment",
        headerTooltip: "Number of Comments on this PR",
        filter: "agNumberColumnFilter",
        width: 150,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.prCommentCount || 0) 
    },
    {
        field: "reviewers",
        headerName: "Reviewers",
        headerTooltip: "Reviewers assigned to review PR.",
        filter: "agTextColumnFilter",
        width: 200,
    }
]

export const commitFileLOCColDef = [
    {
        field: "path",
        headerName: "File Name",
        headerTooltip: "Name of file",
        filter: "agNumberColumnFilter",
        width: 500,
    },
    {
        field: "addedLines",
        headerName: "# LOC: Added",
        headerTooltip: "Number of Added Lines",
        filter: "agNumberColumnFilter",
        width: 130,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.addedLines || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "removedLines",
        headerName: "# LOC: Deleted",
        headerTooltip: "Number of Removed Lines",
        filter: "agNumberColumnFilter",
        width: 130,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.removedLines || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "totalLines",
        headerName: "# LOC: Total",
        headerTooltip: "Total Number of Lines Changed",
        filter: "agNumberColumnFilter",
        width: 130,
        type: 'numericColumn', 
        valueParser: (params) => Number(params.newValue), 
        valueGetter: (params) => Number(params.data?.totalLines || 0) ,
        aggFunc: 'sum',
        suppressAggFuncInHeader: true
    },
    {
        field: "changeType",
        headerName: "Change Type",
        headerTooltip: "Type of change to the file.",
        filter: "agTextColumnFilter",
        width: 130,
        
    }
]